import React, { useState, useEffect } from 'react';
import { login, logout, checkAuth } from './audioStorage';

function AdminGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [ready, setReady] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    checkAuth().then((ok) => {
      setUnlocked(ok);
      setReady(true);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setChecking(true);
    setError(null);
    try {
      await login(input);
      setUnlocked(true);
      setInput('');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setChecking(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    setUnlocked(false);
  };

  if (!ready) return null;

  if (unlocked) {
    return (
      <div>
        <div className="admin-logout-row">
          <button className="admin-logout" onClick={handleLogout}>Lock admin</button>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className="admin-gate text-container">
      <h2>Admin login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Password"
          autoFocus
          className="admin-password-input"
        />
        <button type="submit" disabled={checking || !input}>
          {checking ? 'Checking…' : 'Unlock'}
        </button>
      </form>
      {error && <p className="admin-error">{error}</p>}
    </div>
  );
}

export default AdminGate;
